module.exports = __webpack_public_path__ + "static/img/background2.887f2e77.png";